/* global femcare, Swiper */

femcare.gallery.retailers = {

    init: function () {
        if ($('.product-retailers').length) {
            this.initSliders();
        }
        if ($('.product-main').length) {
            this.initAnalytics();
        }
    },

    initSliders: function () {
        var $retailers = $('.product-retailers');

        if ($retailers.length) {

            var options = {
                lazy: true,
                breakpoints: {
                    350: {
                        slidesPerView: 3.5
                    },
                    500: {
                        slidesPerView: 4
                    },
                    600: {
                        slidesPerView: 5
                    },
                    1200: {
                        slidesPerView: 6
                    }

                },
                navigation: {
                    nextEl: '.product-retailers__next',
                    prevEl: '.product-retailers__previous'
                },
            };

            $retailers.each(function () {
                var instanceOptions = JSON.parse(JSON.stringify(options));
                new Swiper('.product-retailers__slider', instanceOptions);
            });
        }
    },

    initAnalytics: function () {
        window.dataLayer = window.dataLayer || [];
        var productName = $('.product-main__name').text();
        var pageUrl = window.location.href.split('#')[0];

        /** Retailers for click to buy integration (FR market)*/
        $('.product-buy .product-buy__actions a, .product-buy .product-buy__actions button').on('click', function (e) {
            var retailerEventId = $(e.target).parents('.product-buy')[0].dataset.gaEventId;
            var retailer_ga4_data = this.getRetailerGaData(retailerEventId, true)

            window.dataLayer.push({
                event: 'ga4_buy_now_list_retailers',
                ga4_data: retailer_ga4_data
            });

            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push({
                    event: 'gaEvent',
                    eventTrigger: 'buyNowClick',
                    eventCategory: 'Buy Now - List Retailers',
                    eventAction: productName,
                    eventLabel: pageUrl,
                    eventValue: undefined
                });
            }
        }.bind(this));

        /** Retailers for retailers listed on the page*/
        $('.product-retailers__slide').on('click', function (e) {
            var retailerEventId = $(e.target).parents('.product-retailers__slide')[0].dataset.gaEventId;
            var retailer_ga4_data = this.getRetailerGaData(retailerEventId, false);

            window.dataLayer.push({
                event: 'ga4_buy_now_go_to_retailer',
                ga4_data: retailer_ga4_data
            })

            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push({
                    event: 'gaEvent',
                    eventTrigger: 'buyNowClick',
                    eventCategory: 'Buy Now - List Retailers',
                    eventAction: productName,
                    eventLabel: pageUrl,
                    eventValue: undefined
                });
            }
        }.bind(this));

        $('.product-retailers__slide a').on('click', function () {
            var retailerUrl = $(this).attr('href');
            var regex = new RegExp('^(?:https?://)?(?:[^@/n]+@)?(?:www.)?([^:/?n]+)'),
                retailerDomain = regex.exec(retailerUrl);

            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push({
                    event: 'gaEvent',
                    eventTrigger: 'buyNowClick',
                    eventCategory: 'Buy Now - Retailer Click - Retailer Domain',
                    eventAction: productName,
                    eventLabel: retailerDomain[0],
                    eventValue: undefined
                });
            }

            if (typeof window.dataLayer !== 'undefined') {
                window.dataLayer.push({
                    event: 'gaEvent',
                    eventTrigger: 'buyNowClick',
                    eventCategory: 'Buy Now - Retailer Click - Page URL',
                    eventAction: productName,
                    eventLabel: pageUrl,
                    eventValue: undefined
                });
            }
        });
    },

    getRetailerGaData: function(eventId, isRetailersList){
        var productObject = femcare.shared.util.getEntryFromObject(window.gaDataLayer, 'Id', eventId);
        var retailerName = productObject[0].Data.retailer;
        var productId = productObject[0].Data.single_item_id;
        var productName = productObject[0].Data.single_item_name;
        var retailer_ga4_data = {};

        if( isRetailersList ) {
            retailer_ga4_data = {
                single_item_id: productId,
                single_item_name: productName
            }
        } else {
            retailer_ga4_data = {
                retailer: retailerName,
                single_item_id: productId,
                single_item_name: productName
            }
        }

        return retailer_ga4_data;
    }
};